(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-cropper"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const FRAME_WIDTH = 3840;
  const FRAME_HEIGHT = 2160;
  const ASPECT_RATIO = FRAME_WIDTH / FRAME_HEIGHT;

  // --- DOM Elements ---
  const fileInput = document.getElementById('cropper-file-input');
  const uploadBtn = document.getElementById('cropper-upload-btn');
  const downloadBtn = document.getElementById('cropper-download-btn');
  const controlsPanel = document.getElementById('cropper-controls-panel');
  const imageInfo = document.getElementById('cropper-image-info');
  const placeholder = document.getElementById('cropper-placeholder');
  const zoomSlider = document.getElementById('cropper-zoom-slider');
  const zoomInput = document.getElementById('cropper-zoom-input');
  const posXSlider = document.getElementById('cropper-position-x-slider');
  const posYSlider = document.getElementById('cropper-position-y-slider');
  const imageWrapper = document.getElementById('cropper-image-wrapper');
  const imagePreview = document.getElementById('cropper-image-preview');
  const cropBox = document.getElementById('cropper-box-overlay');
  const resizeHandles = document.querySelectorAll('.cropper-resize-handle');
  const editorContainer = document.getElementById('cropper-editor-container');

  // --- State ---
  let sourceImage = null;
  let cropBoxState = { x: 0, y: 0, width: 0, height: 0 };
  let interaction = { type: null, startX: 0, startY: 0, startBox: {} };
  let imageScale = 1;
  let imagePosition = { x: 0, y: 0 };

  // --- Functions ---
  const setControlsEnabled = (enabled) => {
    if (enabled) {
      controlsPanel.classList.remove('cropper-hidden');
      downloadBtn.disabled = false;
      zoomSlider.disabled = false;
      zoomInput.disabled = false;
      posXSlider.disabled = false;
      posYSlider.disabled = false;
    } else {
      controlsPanel.classList.add('cropper-hidden');
    }
  };
  
  const updateImageTransform = () => {
    imagePreview.style.transform = `scale(${imageScale}) translate(${imagePosition.x}px, ${imagePosition.y}px)`;
  };
  
  const updatePositionSliderBounds = () => {
    const imgRect = imagePreview.getBoundingClientRect();
    const containerRect = imageWrapper.getBoundingClientRect();

    const overhangX = Math.max(0, (imgRect.width - containerRect.width) / 2);
    const overhangY = Math.max(0, (imgRect.height - containerRect.height) / 2);

    posXSlider.min = -overhangX;
    posXSlider.max = overhangX;
    posYSlider.min = -overhangY;
    posYSlider.max = overhangY;
    
    // Clamp current position to new bounds
    imagePosition.x = Math.max(-overhangX, Math.min(imagePosition.x, overhangX));
    imagePosition.y = Math.max(-overhangY, Math.min(imagePosition.y, overhangY));
    posXSlider.value = imagePosition.x;
    posYSlider.value = imagePosition.y;

    posXSlider.disabled = overhangX === 0;
    posYSlider.disabled = overhangY === 0;

    updateImageTransform();
  };

  const updateCropBoxStyle = () => {
    cropBox.style.left = `${cropBoxState.x}px`;
    cropBox.style.top = `${cropBoxState.y}px`;
    cropBox.style.width = `${cropBoxState.width}px`;
    cropBox.style.height = `${cropBoxState.height}px`;
  };

  const initCropper = () => {
    placeholder.classList.add('cropper-hidden');
    imageWrapper.style.display = 'flex';
    
    imageScale = 1;
    imagePosition = { x: 0, y: 0 };
    zoomSlider.value = 100;
    zoomInput.value = 100;
    posXSlider.value = 0;
    posYSlider.value = 0;
    updateImageTransform();
    
    setTimeout(() => {
        const imgRect = imagePreview.getBoundingClientRect();
        const containerRect = imageWrapper.getBoundingClientRect();

        let initialWidth, initialHeight;
        if (imgRect.width / imgRect.height > ASPECT_RATIO) {
          initialHeight = imgRect.height * 0.8;
          initialWidth = initialHeight * ASPECT_RATIO;
        } else {
          initialWidth = imgRect.width * 0.8;
          initialHeight = initialWidth / ASPECT_RATIO;
        }
        
        cropBoxState = {
          width: initialWidth,
          height: initialHeight,
          x: (containerRect.width - initialWidth) / 2,
          y: (containerRect.height - initialHeight) / 2
        };
        
        updatePositionSliderBounds();
        updateCropBoxStyle();
        setControlsEnabled(true);
    }, 50);
  };
  
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    loadImageFile(file);
  };
  
  const loadImageFile = (file) => {
    if (!file.type.startsWith('image/')) {
      alert('Please upload a valid image file');
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      sourceImage = new Image();
      sourceImage.onload = () => {
        imagePreview.src = sourceImage.src;
        initCropper(); 
        imageInfo.innerHTML = `Original: ${sourceImage.naturalWidth}x${sourceImage.naturalHeight}px`;
        imageInfo.classList.remove('cropper-hidden');
      };
      sourceImage.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };
  
  const handleZoom = () => {
    imageScale = parseFloat(zoomSlider.value) / 100;
    zoomInput.value = zoomSlider.value;
    updatePositionSliderBounds();
  };

  // --- Unified Event Handler for Mouse and Touch ---
  const getEventCoords = (e) => {
    if (e.touches && e.touches.length > 0) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    }
    return { x: e.clientX, y: e.clientY };
  };

  const onInteractionStart = (e) => {
    e.preventDefault();
    const coords = getEventCoords(e);
    const target = e.target;
    const isHandle = target.classList.contains('cropper-resize-handle');
    
    interaction.startX = coords.x;
    interaction.startY = coords.y;
    interaction.startBox = { ...cropBoxState };

    if (isHandle) {
      interaction.type = 'resize';
      interaction.handle = target.dataset.handle;
    } else if (target === cropBox) {
      interaction.type = 'drag';
    }
    
    if (interaction.type) {
      document.addEventListener('mousemove', onInteractionMove);
      document.addEventListener('mouseup', onInteractionEnd);
      document.addEventListener('touchmove', onInteractionMove, { passive: false });
      document.addEventListener('touchend', onInteractionEnd);
    }
  };

  const onInteractionMove = (e) => {
    if (!interaction.type) return;
    e.preventDefault();
    
    const coords = getEventCoords(e);
    const dx = coords.x - interaction.startX;
    const dy = coords.y - interaction.startY;
    const imgRect = imagePreview.getBoundingClientRect();
    const containerRect = imageWrapper.getBoundingClientRect();
    const bounds = {
      left: imgRect.left - containerRect.left,
      top: imgRect.top - containerRect.top,
      right: imgRect.right - containerRect.left,
      bottom: imgRect.bottom - containerRect.top
    };

    if (interaction.type === 'drag') {
      let newX = interaction.startBox.x + dx;
      let newY = interaction.startBox.y + dy;
      
      newX = Math.max(bounds.left, Math.min(newX, bounds.right - cropBoxState.width));
      newY = Math.max(bounds.top, Math.min(newY, bounds.bottom - cropBoxState.height));

      cropBoxState.x = newX;
      cropBoxState.y = newY;
    } else if (interaction.type === 'resize') {
        let { x, y, width, height } = interaction.startBox;
        
        if (interaction.handle.includes('right')) width += dx;
        if (interaction.handle.includes('left')) { width -= dx; x += dx; }
        
        height = width / ASPECT_RATIO;
        if (interaction.handle.includes('top')) y += interaction.startBox.height - height;

        if (width > 20 && height > 20 && x >= bounds.left && y >= bounds.top && (x + width) <= bounds.right && (y + height) <= bounds.bottom) {
            cropBoxState = { x, y, width, height };
        }
    }
    updateCropBoxStyle();
  };
  
  const onInteractionEnd = () => {
    interaction.type = null;
    document.removeEventListener('mousemove', onInteractionMove);
    document.removeEventListener('mouseup', onInteractionEnd);
    document.removeEventListener('touchmove', onInteractionMove);
    document.removeEventListener('touchend', onInteractionEnd);
  };

  // --- Final Download ---
  const handleDownload = () => {
    if (!sourceImage) return;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = FRAME_WIDTH;
    canvas.height = FRAME_HEIGHT;
    
    const imgDisplayedRect = imagePreview.getBoundingClientRect();
    const containerRect = imageWrapper.getBoundingClientRect();

    const ratio = sourceImage.naturalWidth / imgDisplayedRect.width;

    const sx = (cropBoxState.x - (imgDisplayedRect.left - containerRect.left)) * ratio;
    const sy = (cropBoxState.y - (imgDisplayedRect.top - containerRect.top)) * ratio;
    const sWidth = cropBoxState.width * ratio;
    const sHeight = cropBoxState.height * ratio;

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(sourceImage, sx, sy, sWidth, sHeight, 0, 0, FRAME_WIDTH, FRAME_HEIGHT);

    canvas.toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.download = 'samsung-frame-tv-image.png';
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    }, 'image/png');
  };

  // --- Event Listeners ---
  uploadBtn.addEventListener('click', () => fileInput.click());
  fileInput.addEventListener('change', handleFileUpload);
  downloadBtn.addEventListener('click', handleDownload);
  
  zoomSlider.addEventListener('input', handleZoom);
  zoomInput.addEventListener('change', () => {
      zoomSlider.value = zoomInput.value;
      handleZoom();
  });
  
  posXSlider.addEventListener('input', (e) => {
    imagePosition.x = parseFloat(e.target.value);
    updateImageTransform();
  });
  posYSlider.addEventListener('input', (e) => {
    imagePosition.y = parseFloat(e.target.value);
    updateImageTransform();
  });

  // Mouse events
  cropBox.addEventListener('mousedown', onInteractionStart);
  resizeHandles.forEach(handle => handle.addEventListener('mousedown', onInteractionStart));
  
  // Touch events
  cropBox.addEventListener('touchstart', onInteractionStart, { passive: false });
  resizeHandles.forEach(handle => handle.addEventListener('touchstart', onInteractionStart, { passive: false }));
  
  // --- Drag and Drop Event Listeners ---
  editorContainer.addEventListener('dragover', (e) => {
    e.preventDefault();
    e.stopPropagation();
    editorContainer.classList.add('drag-over');
  });
  
  editorContainer.addEventListener('dragleave', (e) => {
    e.preventDefault();
    e.stopPropagation();
    editorContainer.classList.remove('drag-over');
  });
  
  editorContainer.addEventListener('drop', (e) => {
    e.preventDefault();
    e.stopPropagation();
    editorContainer.classList.remove('drag-over');
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      loadImageFile(files[0]);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
